import { SsMount } from 'src/js/dom/mount.js';
import { velocity } from 'src/js/lib/velocity.js';
import { isLarge } from 'src/js/lib/snif.js';

class SsDoncyou extends SsMount {
  open ( opts = {} ) {
    return velocity( this.elm, {
      props: {
        translateX: [ '0%', '100%' ],
      },
      opts: Object.assign( {
        duration: isLarge() ? 500 : 400,
        easing: 'easeOutSine',
      }, opts ),
    });
  }

  close ( opts = {} ) {
    return velocity( this.elm, {
      props: {
        translateX: [ '100%', '0%' ],
      },
      opts: Object.assign( {
        duration: isLarge() ? 500 : 400,
        easing: 'easeInOutSine',
      }, opts ),
    });
  }
}

export const doncyou = new SsDoncyou(
  document.getElementById( 'ss-doncyou' )
);
